import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input, Dropdown } from 'semantic-ui-react'

import moment from 'moment'

import constants from '../../constants';

class SectionsEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      code: '',
      levelType: '',
      gradeLevel: '',
      showModal: false,
      sectionId: '',
      teacherId: ''
    };
  }

  handleChange = (e, { name, value }) => {
    if(name === 'name') {
      let code = value.replace(/\s/g, '')
      code = code + '-' + this.state.gradeLevel + '-' + moment().format('MMDDYYYY')
      this.setState({ [name]: value, code:  code.toUpperCase() })
    } else {
      this.setState({ [name]: value })
    }
  }

  handleSubmit = () => {
    const data = {
      name: this.state.name,
      code: this.state.code,
      levelType: this.state.levelType,
      gradeLevel: this.state.gradeLevel,
      teacherId: this.state.teacherId,
      schoolYearId: this.props.section.schoolYearId
    };
    this.props.handleUpdate(data,this.state.sectionId);
    this.setState({
      name: '',
      code: '',
      levelType: '',
      gradeLevel: '',
      showModal: false,
      sectionId: '',
      teacherId: ''
    })
    this.closeModal();
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  componentDidMount() {
    this.setState({
      name: this.props.section.name,
      code: this.props.section.code,
      levelType: this.props.section.levelType,
      gradeLevel: this.props.section.gradeLevel,
      sectionId: this.props.section.sectionId,
      teacherId: this.props.section.teacherId
    })
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      name: newProps.section.name,
      code: newProps.section.code,
      levelType: newProps.section.levelType,
      gradeLevel: newProps.section.gradeLevel,
      sectionId: newProps.section.sectionId,
      teacherId: newProps.section.teacherId
    })
  }

  render() {
    let optionsTeachers;
    if (this.props.teachers) {
      optionsTeachers = this.props.teachers.map((teacher,index) => {
        const teacherName = teacher.firstName && teacher.lastName ? 
          teacher.lastName + ', '+ teacher.firstName : 
          'Unknown Teacher';
        return (
            { key: teacher.teacherId, value: teacher.teacherId, text: teacherName }
        )
      })
    }

    const optionsLevelType = constants.levelType;
    const optionsGradeLevel = constants.gradeLevel;

    return (
      <Modal
        trigger={
          <Button icon size='tiny' onClick={this.openModal}>
            <Icon name='pencil' />
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>Edit a Section</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths='equal'>
              <Form.Select
                fluid
                name='levelType'
                label='Level Type'
                placeholder='Level Type'
                options={optionsLevelType}
                onChange={this.handleChange}
                value={this.state.levelType}
              />
              <Form.Select
                fluid
                name='gradeLevel'
                label='Grade Level'
                placeholder='Grade Level'
                options={optionsGradeLevel}
                onChange={this.handleChange}
                value={this.state.gradeLevel}
              />
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.name} name='name' label='Name' placeholder='Name' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.code} name='code' label='Code' placeholder='Code' disabled  className='section-disabled'/>
            </Form.Group>
            Teacher
            <Dropdown
              search
              selection
              fluid
              name='teacherId'
              className='teacher-dropdown'
              options={optionsTeachers}
              onChange={this.handleChange}
              value={this.state.teacherId}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.handleSubmit()}>Submit</Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default SectionsEdit;
